// src/oura/components/docs/createRequest.ts
//
// A `?create=` link (Ask Oura, preview): open Create a doc on the Documents
// card with this doc type picked. The request carries the client it was made
// on, so another client's board never opens it.

export interface CreateRequest {
    /** The client whose link this was. */
    businessId: string;
    /** The doc type to pick, or null for "new" (nothing picked). */
    docType: string | null;
    codes: string[];
    outlet: string | null;
}

/** The request when it was made on this client, else null: another client's request is never opened here. */
export function createRequestFor(request: CreateRequest | null | undefined, businessId: string): CreateRequest | null {
    return request && request.businessId === businessId ? request : null;
}
